import handleNavigation from '@/utils/navigationUtils';
import { dispatchActionLink, isActionLink } from '@/utils/actionLinks';
import mobileUtils from '@/utils/appUtils/mobileUtils';

export const isAbsoluteUrl = (href) => /^https?:\/\//i.test(href || '');

export const addExternalLinkAttrs = (html) => {
  const container = document.createElement('div');
  container.innerHTML = html;
  container.querySelectorAll('a[href]').forEach((anchor) => {
    if (isAbsoluteUrl(anchor.getAttribute('href'))) {
      anchor.setAttribute('target', '_blank');
      anchor.setAttribute('rel', 'noopener noreferrer');
    }
  });
  return container.innerHTML;
};

const openAbsoluteUrl = (href) => {
  if (mobileUtils.isFeatureSupported('openInAppBrowser')) {
    mobileUtils.openInAppBrowser(href);
    return;
  }
  window.open(href, '_blank', 'noopener,noreferrer');
};

// Like openAbsoluteUrl, but always opens in the device's external system browser
// (never the in-app browser) - for callers where the in-app browser is undesirable.
export const openExternalUrl = (href) => {
  if (mobileUtils.isFeatureSupported('openExternalBrowser')) {
    mobileUtils.openExternalBrowser(href);
    return;
  }
  window.open(href, '_blank', 'noopener,noreferrer');
};

export const handleLinkClick = (event) => {
  const anchor = event.target.closest('a');
  if (!anchor) return false;
  const href = anchor.getAttribute('href');
  if (!href) return false;
  if (isAbsoluteUrl(href)) {
    if (mobileUtils.isFeatureSupported('openInAppBrowser')) {
      event.preventDefault();
      openAbsoluteUrl(href);
    }
    return false;
  }
  event.preventDefault();
  // "/app/action/openModal/..." links open a modal instead of navigating.
  if (isActionLink(href)) return dispatchActionLink(href);
  handleNavigation({ path: href });
  return true;
};
